<template>
  <el-dialog
    center
    width="600px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @close="resetFrom('form')"
    @open="openDialog"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item
        label="用户名"
        :label-width="formLabelWidth"
        prop="custUserId"
        style="margin-bottom: 20px"
      >
        <UserSelect @setUserId="setUserId" ref="UserSelect" />
      </el-form-item>

      <el-form-item label="楼盘名" :label-width="formLabelWidth" prop="houseId">
        <HouseSelect @setHouseId="setHouseId" ref="HouseSelect" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('form');
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { setCustSerApi, addCustSerApi } from '@/api/allot.js';
import HouseSelect from './houseSelect';
import UserSelect from './userSelect';
export default {
  name: 'AllotForm',
  inject: ['reload'],
  components: {
    HouseSelect,
    UserSelect,
  },
  data() {
    return {
      dialogFormVisible: false,
      dialogTitle: '',
      fromAppMainData: null,
      form: {
        houseId: '',
        custUserId: '',
        custSerId: '',
      },
      rules: {
        houseId: [
          { required: true, message: '楼盘名不能为空', trigger: 'blur' },
        ],
        custUserId: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
        ],
      },
      formLabelWidth: '120px',
    };
  },
  methods: {
    // 打开表单赋值
    openDialog() {
      this.$nextTick(() => {
        if (this.fromAppMainData == null) return;
        let { custSerId, ququestUser, house } = this.fromAppMainData;
        this.custSerId = custSerId;
        this.form.custUserId = ququestUser.userId;
        this.form.custSerId = custSerId;
        this.$refs.UserSelect.userName = ququestUser.nickName;
        this.form.houseId = house.houseId;
        this.$refs.HouseSelect.houseName = house.houseName;
      });
    },

    resetFrom() {
      // console.log('执行了函数');
      this.$refs.HouseSelect.houseName = '';
      this.$refs.UserSelect.userName = '';
      this.form = {
        houseId: '',
        custUserId: '',
      };
    },

    // 确认提交
    submitEdit() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          const areaId = localStorage.getItem('areaId')
            ? JSON.parse(localStorage.getItem('areaId')).areaId
            : '';
          let { houseId, custUserId, custSerId } = this.form;
          // 编辑表单
          if (this.dialogTitle.includes('编辑')) {
            // let data =
            //   'custSerId=' +
            //   this.custSerId +
            //   '&houseId=' +
            //   this.form.houseId +
            //   '&custUserId=' +
            //   this.form.custUserId;
            await setCustSerApi({
              houseId,
              custUserId,
              custSerId,
              areaId,
            }).then((res) => {
              if (res.code === 200) this.$message.success('编辑成功!');
            });
          } else {
            // 增加表单
            // let data =
            //   'houseId=' +
            //   this.form.houseId +
            //   '&custUserId=' +
            //   this.form.custUserId;

            await addCustSerApi({ houseId, custUserId, areaId }).then((res) => {
              if (res.code === 200) this.$message.success('新增成功!');
            });
          }
          this.dialogFormVisible = false;
          this.form = {};
          // 重新获取数据
          this.reload();
        });
      } catch (e) {
        window.console.log(e);
      }
    },

    setHouseId(val) {
      this.form.houseId = val;
    },

    setUserId(val) {
      this.form.custUserId = val;
    },
  },
};
</script>

<style></style>
